module.exports = __webpack_public_path__ + "assets/img/3c30d26208dd2769b2f4361c87a6b1bc.png";